import { render, staticRenderFns } from "./AppVerification.vue?vue&type=template&id=6b5f0b64&scoped=true&"
import script from "./AppVerification.vue?vue&type=script&lang=ts&"
export * from "./AppVerification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5f0b64",
  null
  
)

export default component.exports